<template>
  <div style="margin-top:70px;">

    <admin-tab-navigation />
   
    <div class="mt-3"> 
      <admin-root v-if="activeOption == 'admin-root'" />
      <admin-activities v-if="activeOption == 'admin-activities'" />
      <admin-activity-groups v-if="activeOption == 'admin-activity-groups'" />
      <admin-stop-schedules v-if="activeOption == 'admin-stop-schedules'" />
      <admin-geopoints v-if="activeOption == 'admin-geopoints'" />
      <admin-hotel-stop-groups v-if="activeOption == 'admin-hotel-stop-groups'" />
      <admin-subzones v-if="activeOption == 'admin-subzones'" />
      <admin-pickupzones v-if="activeOption == 'admin-pickupzones'" />
      <admin-suprazones v-if="activeOption == 'admin-suprazones'" />
      <admin-bus-companies v-if="activeOption == 'admin-bus-companies'" />
      <admin-bus-companies-prices v-if="activeOption == 'admin-bus-companies-prices'" />
      <admin-activity-duration-types v-if="activeOption == 'admin-activity-duration-types'" />
      <admin-guides v-if="activeOption == 'admin-guides'" />
      <admin-export v-if="activeOption == 'admin-export'" />
      <admin-secrets v-if="activeOption == 'admin-secrets'" />
      <admin-help v-if="activeOption == 'admin-help'" />
    </div>

    <span v-if="isDataLoading" class="badge badge-danger my-2 badge-loading">
        <i class="fa fa-spinner fa-spin mx-2 my-1"></i>
        Petición en proceso... espere por favor
    </span>

  </div>
</template>

<script>
/* eslint-disable */
import AdminTabNavigation from '../../components/Admin/AdminTabNavigation'
import AdminActivities from '../../components/Admin/Activities/AdminActivities'
import AdminActivityGroups from '../../components/Admin/ActivityGroups/AdminActivityGroups'
import AdminStopSchedules from '../../components/Admin/AdminStops/AdminStopSchedules'
import AdminGeopoints from '../../components/Admin/Geopoints/AdminGeopoints'
import AdminHotelStopGroups from '../../components/Admin/HotelStopGroups/AdminHotelStopGroups'
import AdminSuprazones from '../../components/Admin/Suprazones/AdminSuprazones'
import AdminSubzones from '../../components/Admin/Subzones/AdminSubzones'
import AdminPickupzones from '../../components/Admin/Pickupzones/AdminPickupzones'
import AdminBusCompanies from '../../components/Admin/BusCompanies/AdminBusCompanies'
import AdminBusCompaniesPrices from '../../components/Admin/BusCompaniesPrices/AdminBusCompaniesPrices'
import AdminActivityDurationTypes from '../../components/Admin/ActivityDurationTypes/AdminActivityDurationTypes'
import AdminGuides from '../../components/Admin/Guides/AdminGuides'
import AdminExport from '../../components/Admin/AdminExport'
import AdminSecrets from '../../components/Admin/AdminSecrets'
import AdminHelp from '../../components/Admin/Help/AdminHelp'
import AdminRoot from '../../components/Admin/AdminRoot'
import { mapGetters } from "vuex";

export default {
  components: {
    AdminTabNavigation,
    AdminActivities,
    AdminActivityGroups,
    AdminStopSchedules,
    AdminGeopoints,
    AdminHotelStopGroups,
    AdminSuprazones,
    AdminPickupzones,
    AdminSubzones,
    AdminBusCompanies,
    AdminBusCompaniesPrices,
    AdminActivityDurationTypes,
    AdminGuides,
    AdminExport,
    AdminSecrets,
    AdminHelp,
    AdminRoot,
  },
  created() {
    this.$store.dispatch('layout/setActiveTabAndOption', {tab: 'Admin', option: 'admin-root'})
  },
  computed: {
      ...mapGetters(["trekksoftClient", 'activeTab', 'activeOption', 'isDataLoading'])
  },
  
};
</script>

<style scoped>
.badge-loading {
  padding: 5px 10px;
  margin-left: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  color: white;
}
</style>
